import {
    ElementFormatType,
    LexicalEditor,
    SerializedEditorState,
    SerializedTextNode,
} from 'lexical'
import { SerializedBaseNode } from '../nodes/BaseNode'

type TextContent = {
    text: string
}
export type SerializedContent = {
    children: TextContent[]
    id: string
    type: string
    version: number
}
//convert DB Json to Lexical JSON format
//TODO : handle version here
export function convertDBToLexicalJSON(data: SerializedContent[]) {
    return {
        root: {
            type: 'root',
            version: 1,
            children: data.map((node) => ({
                type: node.type,
                id: node.id,
                version: node.version,
                children: node.children?.map((child) => ({
                    type: 'text',
                    text: child.text || ' ',
                    version: 1,
                    style: '',
                    format: '', // must match Lexical format type
                    detail: 0,
                    mode: 'normal',
                })),
                direction: null, // ✅ must be one of "ltr", "rtl", or null
                format: '', // ✅ matches Lexical’s expected format
                indent: 0,
            })),
            direction: null, // ✅
            format: '' as ElementFormatType,
            indent: 0,
        },
    }
}
export function convertLexicalToDBJson(editorState: SerializedEditorState): SerializedContent[] {
    return editorState.root.children.map((nodeJson) => {
        const node = nodeJson as SerializedBaseNode
        const custom = {
            type: node.type,
            id: node.id,
            children: (node.children as SerializedTextNode[]).map((child) => ({
                text: child.text || '',
            })),
            version: node.version,
        }
        return custom
    })
}
export function convertLexicalTextToDBJson(textNode: SerializedTextNode) {
    return { text: textNode.text || '' }
}
export function setJsonScriptEditor(editor: LexicalEditor | null, jsonScript: any[]) {
    const json = convertDBToLexicalJSON(jsonScript)
    const parsedState = editor?.parseEditorState(json)
    if (parsedState) {
        editor?.setEditorState(parsedState)
    }
}

export function serializedContentToString(content: SerializedContent[]): string {
    return content
        .map((block) => {
            const text = block.children.map((child) => child.text).join('')
            return text
        })
        .join('\n\n') // Add spacing between blocks
}
